<template>
    <Disclosure as="nav" class="bg-white" v-slot="{ open }">
        <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div class="relative flex h-30 items-center justify-between">
                <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
                    <!-- Mobile menu button-->
                    <DisclosureButton
                        class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset">
                        <span class="absolute -inset-0.5"></span>
                        <span class="sr-only">Open main menu</span>
                        <Bars3Icon v-if="!open" class="block size-6" aria-hidden="true" />
                        <XMarkIcon v-else class="block size-6" aria-hidden="true" />
                    </DisclosureButton>
                </div>
                <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                    <a href="/" class="flex shrink-0 items-center">
                        <img class="h-30 w-auto object-cover" src="/images/logo.png" alt="logo" />
                    </a>
                    <div class="hidden sm:ml-6 sm:block">
                        <div class="flex space-x-4 h-full items-center">
                            <div as="div" class="relative flex justify-start items-center text-left">
                                <div v-for="item in navigation" :key="item.name">
                                    <router-link :to="item.href" v-if="!item.dropdown" :class="[
                                            item.current ? 'bg-emerald-500 text-white' : 'hover:bg-emerald-500 hover:text-white',
                                            item.color ? item.color : 'text-gray-800',
                                            'rounded-md px-3 py-2 text-sm font-medium'
                                        ]" :aria-current="item.current ? 'page' : undefined">
                                        {{ item.name }}
                                    </router-link>

                                    <Menu v-else as="div" class="relative">
                                        <MenuButton
                                            :class="[item.current ? 'bg-emerald-500 text-white' : 'text-gray-800 hover:bg-emerald-500 hover:text-white', 'rounded-md px-3 py-2 text-sm font-medium']"
                                            class="flex" :aria-current="item.current ? 'page' : undefined">
                                            <img v-if="item.icon" :src="item.icon" alt="" class="w-5 h-5 rounded-sm" />
                                            {{ item.name }}
                                            <ChevronDownIcon class="ml-2 -mr-1 h-5 w-5 text-gray-800 inline-block"
                                                aria-hidden="true" />
                                        </MenuButton>
                                        <Transition enter="transition ease-out duration-100"
                                            enter-from="transform opacity-0 scale-95"
                                            enter-to="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leave-from="transform opacity-100 scale-100"
                                            leave-to="transform opacity-0 scale-95">
                                            <MenuItems
                                                class="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-gray-300 ring-opacity-5 focus:outline-none z-50">
                                                <div class="px-1 py-1">
                                                    <MenuItem v-slot="{ active }" v-for="subItem in item.dropdown.items"
                                                        @click="subItem.onClick" :key="subItem.name">
                                                    <router-link v-if="subItem.href" :to="subItem.href" :class="[
                                                            active ? 'bg-gray-200 text-gray-700' : 'text-gray-900',
                                                            'group flex w-full items-center rounded-md px-2 py-2 text-sm'
                                                        ]">
                                                        {{ subItem.name }}
                                                    </router-link>

                                                    <button v-else @click="subItem.onClick" :class="[
                                                                active ? 'bg-gray-200 text-gray-700' : 'text-gray-900',
                                                                'group flex w-full items-center rounded-md px-2 py-2 text-sm'
                                                            ]">
                                                        <img :src="subItem.flag" alt=""
                                                            class="w-5 h-5 rounded-sm me-2" />
                                                        {{ subItem.name }}
                                                    </button>
                                                    </MenuItem>
                                                </div>
                                            </MenuItems>
                                        </Transition>
                                    </Menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="user">
                    <Menu as="div" class="relative flex justify-start items-center text-left">
                        <div>
                            <div class="relative">
                                <MenuButton
                                    class="flex items-center text-sm rounded-full focus:outline-hidden focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                                    <img class="h-8 w-8 rounded-full" :src="user.avatar || '/images/default-avatar.png'"
                                        alt="User Avatar" />
                                    <ChevronDownIcon class="ml-2 -mr-1 h-5 w-5 text-gray-800 inline-block"
                                        aria-hidden="true" />
                                </MenuButton>
                                <Transition enter="transition ease-out duration-100"
                                    enter-from="transform opacity-0 scale-95" enter-to="transform opacity-100 scale-100"
                                    leave="transition ease-in duration-75" leave-from="transform opacity-100 scale-100"
                                    leave-to="transform opacity-0 scale-95">
                                    <MenuItems
                                        class="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-gray-300 ring-opacity-5 focus:outline-none z-50">
                                        <div class="px-1 py-1">
                                            <MenuItem v-slot="{ active }" v-for="item in userDropdownItems"
                                                :key="item.name">
                                            <a :href="item.href" :class="[
                                                active ? 'bg-gray-200 text-gray-700' : 'text-gray-900',
                                                'group flex w-full items-center rounded-md px-2 py-2 text-sm'
                                            ]">
                                                <component :is="item.icon" class="mr-2 h-5 w-5 text-gray-500" />
                                                <span>{{ item.name }}</span>
                                            </a>
                                            </MenuItem>
                                        </div>
                                    </MenuItems>
                                </Transition>
                            </div>
                        </div>
                    </Menu>
                </div>
                <div v-else class="hidden sm:flex sm:items-center sm:justify-end">
                    <router-link to="/register" class="text-sm font-semibold text-white">
                        <Button variant="primary" size="sm" class="me-2">
                            {{ t('headings.register') }}
                        </Button>
                    </router-link>
                    <router-link to="/login" class="text-sm font-semibold text-primary">
                        <Button variant="outlined" size="sm">
                            {{ t('headings.login') }}
                        </Button>
                    </router-link>
                </div>
            </div>
        </div>

        <DisclosurePanel class="sm:hidden">
            <div class="space-y-1 px-2 pt-2 pb-3">
                <!-- Regular navigation items -->
                <template v-for="item in navigation" :key="item.name">
                    <!-- Skip language dropdown in mobile menu -->
                    <template v-if="item.name && !item.icon">
                        <!-- Items with dropdown -->
                        <div v-if="item.dropdown && item.dropdown.items.length > 0">
                            <DisclosureButton as="div" class="block rounded-md px-3 py-2 text-base font-medium text-gray-800">
                                {{ item.name }}
                            </DisclosureButton>
                            <div class="pl-4">
                                <DisclosureButton v-for="subItem in item.dropdown.items" :key="subItem.name" 
                                    as="a" :href="subItem.href"
                                    class="block rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800">
                                    {{ subItem.name }}
                                </DisclosureButton>
                            </div>
                        </div>
                        <!-- Regular items -->
                        <DisclosureButton v-else as="a" :href="item.href"
                            :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-800 hover:bg-gray-700 hover:text-white', 'block rounded-md px-3 py-2 text-base font-medium']"
                            :aria-current="item.current ? 'page' : undefined">
                            {{ item.name }}
                        </DisclosureButton>
                    </template>
                </template>
                
                <!-- Language selection in mobile menu -->
                <div class="border-t border-gray-200 pt-4 mt-4">
                    <div class="px-3 py-2 text-base font-medium text-gray-800">{{ t('headings.language') }}</div>
                    <div class="pl-4 space-y-1">
                        <button @click="changeLocale('en')" 
                            class="flex items-center w-full px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md">
                            <img :src="usFlag" alt="English" class="w-5 h-5 rounded-sm me-2" />
                            English
                        </button>
                        <button @click="changeLocale('fr')" 
                            class="flex items-center w-full px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md">
                            <img :src="frFlag" alt="Français" class="w-5 h-5 rounded-sm me-2" />
                            Français
                        </button>
                        <button @click="changeLocale('ar')" 
                            class="flex items-center w-full px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md">
                            <img :src="arFlag" alt="العربية" class="w-5 h-5 rounded-sm me-2" />
                            العربية
                        </button>
                    </div>
                </div>

                <!-- User menu in mobile -->
                <div v-if="user" class="border-t border-gray-200 pt-4 mt-4">
                    <div class="flex items-center px-3 py-2">
                        <img class="h-8 w-8 rounded-full" :src="user.avatar || '/images/default-avatar.png'" alt="User Avatar" />
                        <div class="ml-3">
                            <div class="text-base font-medium text-gray-800">{{ user.name }}</div>
                            <div class="text-sm font-medium text-gray-500">{{ user.email }}</div>
                        </div>
                    </div>
                    <div class="mt-3 space-y-1">
                        <DisclosureButton v-for="item in userDropdownItems" :key="item.name"
                            as="a" :href="item.href"
                            class="flex items-center px-3 py-2 text-base font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-md">
                            <component :is="item.icon" class="mr-3 h-5 w-5 text-gray-500" />
                            {{ item.name }}
                        </DisclosureButton>
                    </div>
                </div>

                <!-- Auth buttons for mobile when not logged in -->
                <div v-else class="border-t border-gray-200 pt-4 mt-4 space-y-2">
                    <router-link to="/register" class="block">
                        <Button variant="primary" size="sm" class="w-full">
                            {{ t('headings.register') }}
                        </Button>
                    </router-link>
                    <router-link to="/login" class="block">
                        <Button variant="outlined" size="sm" class="w-full">
                            {{ t('headings.login') }}
                        </Button>
                    </router-link>
                </div>
            </div>
        </DisclosurePanel>
    </Disclosure>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { 
    Bars3Icon,
    BellIcon,
    XMarkIcon,
    AcademicCapIcon,
    UserIcon,
    ArrowLeftEndOnRectangleIcon
} from '@heroicons/vue/24/outline';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import Button from 'primevue/button';
import { useAuth } from '@/composables/useAuth';
import { onMounted } from 'vue';
import { getFeaturedCategories } from '@/services/categoryService';
import { ref } from 'vue';
import usFlag from '@/images/flags/us.png'
import frFlag from '@/images/flags/fr.png'
import arFlag from '@/images/flags/ar.png'
import { useI18n } from 'vue-i18n'

const { locale: currentLocale } = useI18n();
const { getUser } = useAuth();
const user = ref(null);
const categories = ref([]);

const { t } = useI18n();

const getCurrentLanguageFlag = () => {
    const currentLang = window.appLocale || 'en';
    switch (currentLang) {
        case 'fr':
            return frFlag;
        case 'ar':
            return arFlag;
        default:
            return usFlag;
    }
};

const navigation = [
    {
        name: t('headings.programs'), href: '#', current: false, dropdown: {
            items: []
        }
    },
    { name: t('headings.books'), href: '/books', current: false, dropdown: false },
    { name: t('headings.about-us'), href: '/about-us', current: false, dropdown: false },
    { name: t('headings.testimonials'), href: '/#testimonials', current: false, dropdown: false },
    { name: t('headings.contact-us'), href: '/contact-us', current: false, dropdown: false },
    { name: t('headings.privacy-policy'), href: '/privacy-policy', current: false, dropdown: false },
    {
        name: '', href: '#', current: false, dropdown: {
            items: [
                { name: 'English', href: null, current: false, flag: usFlag, onClick: () => changeLocale('en') },
                { name: 'Français', href: null, current: false, flag: frFlag, onClick: () => changeLocale('fr') },
                { name: 'العربية', href: null, current: false, flag: arFlag, onClick: () => changeLocale('ar') }
            ]
        }, icon: getCurrentLanguageFlag()
    },
];

const userDropdownItems = [
    { name: t('headings.account'), href: '/account', icon: UserIcon },
    { name: t('headings.learning'), href: '/learning', icon: AcademicCapIcon },
    { name: t('headings.logout'), href: '/logout', icon: ArrowLeftEndOnRectangleIcon }
];

const changeLocale = (locale) => {
    currentLocale.value = locale;
    // axios.get(`/locale/${locale}`, { headers: { 'Accept': 'application/json' } });
    window.location.href = `/locale/${locale}?redirect=${window.location.pathname}`;
};

onMounted(() => {
    getUser()
        .then(userData => {
            user.value = userData;
        })
        .catch(error => {
            // console.error('Error fetching user data:', error);
        });

    getFeaturedCategories().then(data => {
        categories.value = data.data;

        navigation[0].dropdown.items = categories.value.map(category => ({
            name: category.name,
            href: `/courses?category=${category.slug}`
        }));
    });
})
</script>